/** Existing location metadata only; never fetches or reveals restricted historical notes. */
export function LocationDescription({ description }: { description?: string | null }) {
  if (!description?.trim()) return null;
  return (
    <section className="panel panel-pad section" aria-label="Site description" id="description">
      <header className="section-header">
        <h2>Site description</h2>
      </header>
      <p className="muted">Site metadata — separate from historical notes and source history.</p>
      <div style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{description}</div>
    </section>
  );
}
